<template>
	<nav class="flex xxl:gap-x-1">
		<slot name="prefix" />
		<template v-for="(item, index) in menuLinks" :key="index">
			<HeaderNavButton v-if="item.dropdown || item.items" :button="item" :font-bold="fontBold" />
			<AbsoluteInternalLink
				v-else
				:to="item.url"
				class="
					block
					px-1.5
					xl:px-2
					py-3
					relative
					whitespace-nowrap
					text-center
					transition
					ease
					text-base
					after:transition
					after:ease
					after:absolute
					after:bottom-0
					after:inset-x-0
					after:h-[.1875rem]
					after:rounded-t-lg
					hover:after:bg-background-important
					focus-outline
					[&.router-is-active]:after:bg-background-important
				"
				:class="{'font-bold': fontBold}"
				:target="item.target ?? '_self'"
				@click="trackHeaderEvent('text_top', item.label)"
			>
				{{ item.label }}
				<NuxtIcon
					v-if="item.suffixIcon"
					:name="item.suffixIcon"
					class="text-icon-tertiary text-md inline-flex ml-1 relative top-0.5"
					filled
				/>
			</AbsoluteInternalLink>
		</template>
	</nav>
</template>

<script setup lang="ts">
	import type {MenuLink} from '~/types/header';

	type Props = {
		menuLinks: MenuLink[];
		fontBold?: boolean;
	};

	defineProps<Props>();
</script>
